import { Fragment, useContext, useEffect, useState } from "react";
import { Popover, Transition } from "@headlessui/react";
import { MenuIcon, XIcon } from "@heroicons/react/outline";
import { ChevronDownIcon } from "@heroicons/react/solid";
import Web3Context from "../context/Web3Context";
import TokenHandle from "../context/TokenHandle";
import { Link as LinkS } from "react-scroll";
import { Link } from "react-router-dom";
import clsx from "clsx";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const solutions = [
  {
    name: "Invest",
    href: "dashboard",
  },
];

const whitepapper = [
  {
    name: "",
    href: "https://birdstaking.gitbook.io/bird-staking/",
  },
];

export default function Navbar() {
  const { accounts, isLoaded, balanceOf_ } = useContext(Web3Context);
  const { BnbPrice } = useContext(TokenHandle);

  const [acount_, setacount_] = useState("0x");
  let [isOpaque, setIsOpaque] = useState(false);

  useEffect(() => {
    let offset = 50;
    function onScroll() {
      if (!isOpaque && window.scrollY > offset) {
        setIsOpaque(true);
      } else if (isOpaque && window.scrollY <= offset) {
        setIsOpaque(false);
      }
    }
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", onScroll, { passive: true });
    };
  }, [isOpaque]);

  useEffect(() => {
    console.log();
    const start = "0X...";
    const end = accounts.slice(38);
    setacount_(`${start}...${end}`);
    return () => {};
  }, [accounts]);

  return (
    <>
      <div class="absolute z-20 top-0 inset-x-0 flex justify-center overflow-hidden pointer-events-none">
        <div class="w-[108rem] flex-none flex justify-end">
          <picture>
            <img
              src="/header1.avif"
              alt=""
              class="w-[71.75rem] flex-none max-w-none "
            />
          </picture>
        </div>
      </div>
      <Popover
        className={clsx(
          "sticky top-0 z-40 w-full border-b border-gray-200  backdrop-blur flex-none transition-colors duration-500 lg:z-50 lg:border-b lg:border-slate-900/10",
          isOpaque
          ? 'bg-white supports-backdrop-blur:bg-white/95'
          : 'bg-white/95 supports-backdrop-blur:bg-white/60'
        )}
      >
        {({ open, close }) => (
          <>
            <div className="max-w-7xl mx-auto px-4 sm:px-6">
              <div className="flex justify-between items-center py-6 md:justify-start md:space-x-10">
                <div className="flex justify-start lg:w-0 lg:flex-1">
                  <a href="#">
                    <span className="sr-only">Workflow</span>
                    <img
                      className="h-10 w-auto sm:h-12 rounded-lg bg-slate-800 p-2"
                      src="/logo.png"
                      alt=""
                    />
                  </a>
                </div>
                <div className="-mr-2 -my-2 md:hidden">
                  <Popover.Button className="bg-white border border-slate-200 rounded-md p-2 inline-flex items-center justify-center text-black  ">
                    <span className="sr-only">Open menu</span>
                    <MenuIcon className="h-6 w-6" aria-hidden="true" />
                  </Popover.Button>
                </div>
                <Popover.Group as="nav" className="hidden md:flex space-x-7">
                  <Link
                    to="/"
                    className="text-base font-medium text-gray-800 hover:text-gray-900 cursor-pointer"
                  >
                    Home
                  </Link>
                  <a
                    target={`_blank`}
                    href="https://birdstaking.gitbook.io/bird-staking/"
                    onClick={() => window.open(`https://birdstaking.gitbook.io/bird-staking/`)}
                    className="-m-3 p-3 block rounded-md  cursor-pointer"
                  >
                    <p className="text-base font-medium text-gray-900">
                      Whitepaper
                    </p>
                  </a>
                  <LinkS
                    to="dashboard"
                    spy={true}
                    smooth={true}
                    offset={-10}
                    duration={500}
                    className="text-base font-medium text-gray-800 hover:text-gray-900 cursor-pointer"
                  >
                    Invest
                  </LinkS>
                  <a
                    href="https://bscscan.com/address/0x09180eb78a3cb64db28d058382428f6553612ee9#code"
                    target={`_blank`}
                    className="text-base font-medium text-gray-800 hover:text-gray-900"
                  >
                    Contract
                  </a>
                </Popover.Group>
                <div className="hidden md:flex items-center justify-end md:flex-1 lg:w-0">
                  <a
                    href="#"
                    className="ml-8 whitespace-nowrap inline-flex items-center justify-center px-4 py-2 border border-transparent rounded-md shadow-sm text-base font-medium text-white bg-slate-900"
                  >
                    {acount_}
                  </a>
                </div>
              </div>
            </div>

            <Transition
              as={Fragment}
              enter="duration-200 ease-out"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="duration-100 ease-in"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Popover.Panel
                focus
                className="absolute top-0 inset-x-0 p-2 transition transform origin-top-right md:hidden"
              >
                <div className="rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 bg-white divide-y-2 divide-gray-50">
                  <div className="pt-5 pb-6 px-5">
                    <div className="flex items-center justify-between">
                      <div>
                        <img
                          className="h-8 w-auto rounded-lg bg-slate-800 p-1"
                          src="/logo.png"
                          alt="Workflow"
                        />
                      </div>
                      <div className="-mr-2">
                        <Popover.Button className="bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-900  hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-yellow-500">
                          <span className="sr-only">Close menu</span>
                          <XIcon className="h-6 w-6" aria-hidden="true" />
                        </Popover.Button>
                      </div>
                    </div>
                    <div className="mt-6">
                      <nav className="grid gap-y-8">
                        <Link
                          to="/"
                          className="-m-3 p-3 flex items-center rounded-md hover:bg-gray-50 cursor-pointer"
                        >
                          <span className="ml-3 text-base font-medium text-gray-900">
                            Home
                          </span>
                        </Link>
                        {solutions.map((item) => (
                          <LinkS
                            key={item.name}
                            to={item.href}
                            spy={true}
                            smooth={true}
                            offset={-10}
                            duration={500}
                            onClick={() => {
                              close();
                            }}
                            className="-m-3 p-3 flex items-center rounded-md hover:bg-gray-50 cursor-pointer"
                          >
                            <span className="ml-3 text-base font-medium text-gray-900">
                              {item.name}
                            </span>
                          </LinkS>
                        ))}
                        {whitepapper.map((item, i) => (
                          <a
                            key={i}
                            href={item.href}
                            target={`_blank`}
                            onClick={() => window.open(`${item.href}`)}
                            className="-m-3 p-3 flex items-center rounded-md hover:bg-gray-50 cursor-pointer"
                          >
                            <p className="ml-3 text-base font-medium text-gray-900">
                              Whitepaper {item.name}
                            </p>
                          </a>
                        ))}
                        <a
                          href="https://bscscan.com/address/0x09180eb78a3cb64db28d058382428f6553612ee9#code"
                          target={`_blank`}
                          onClick={() => {
                            close();
                          }}
                          className="-m-3 p-3 flex items-center rounded-md hover:bg-gray-50 cursor-pointer"
                        >
                          <span className="ml-3 text-base font-medium text-gray-900">
                            Contract
                          </span>
                        </a>
                      </nav>
                    </div>
                  </div>
                  <div className="py-6 px-5 space-y-6">
                    <div>
                      <a
                        href="#"
                        className="w-full flex items-center justify-center px-4 py-2 border border-transparent rounded-md shadow-sm text-base font-medium bg-slate-900 text-white"
                      >
                        {acount_}
                      </a>
                    </div>
                  </div>
                </div>
              </Popover.Panel>
            </Transition>
          </>
        )}
      </Popover>
    </>
  );
}